"use client";

import { Navbar1 } from "@/components/ui/Standards/navbar";
import { Footer7 } from "@/components/ui/Standards/footer-7";
import { Badge } from "@/components/ui/badge";
import Image from "next/image";
import CloudWatchForm from "@/components/ui/cloud-watch-form";

export default function VentilationInstallationPage() {
  return (
    <>
      <Navbar1 />
      <main className="min-h-screen bg-background">
        {/* Hero Section */}
        <section className="container px-4 py-16 mx-auto lg:py-24">
          <h1 className="mb-6 text-5xl font-bold tracking-tight md:text-6xl">
            Behöver du hjälp?
          </h1>
          <p className="max-w-3xl text-xl leading-relaxed text-muted-foreground">
            Vi rekommenderar dessa pålitliga företag för ventilationslösningar.
            De har erfarenheten och kunskapen att hjälpa dig.
          </p>
        </section>

        {/* Rekommenderade företag Section */}
        <section className="w-full py-16 bg-muted/30">
          <div className="container px-4 mx-auto">
            <div className="mb-12 text-center">
              <h2 className="mb-4 text-4xl font-bold tracking-tight md:text-5xl">
                Rekommenderade företag
              </h2>
              <p className="max-w-2xl mx-auto text-lg text-muted-foreground">
                Enrumsventilation.se drivs av miniftx.se och villaklimat.se - företag vi litar på
              </p>
            </div>

            {/* Mini-FTX Row */}
            <div className="grid grid-cols-1 gap-8 mb-16 lg:grid-cols-2">
              {/* Mini-FTX Text + Logo */}
              <div className="flex flex-col justify-center gap-6 p-8 bg-white shadow-lg rounded-xl">
                <div>
                  <Badge className="mb-4">Mini-FTX Installation</Badge>
                </div>
                <div className="flex flex-col gap-2">
                  <a
                    href="https://miniftx.se"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-2xl font-semibold tracking-tight hover:text-primary transition-colors"
                  >
                    Mini-FTX.se
                  </a>
                  <p className="text-base leading-relaxed text-muted-foreground">
                    Sveriges ledande aktör inom mini-FTX och enrumsventilation.
                    Vi erbjuder högkvalitativa produkter för energieffektiv
                    ventilation i enskilda rum.
                  </p>
                  <a
                    href="https://miniftx.se"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center mt-2 text-sm font-medium text-primary hover:underline"
                  >
                    Besök miniftx.se →
                  </a>
                </div>
                {/* Logo */}
                <div className="relative w-full h-24 mt-4">
                  <Image
                    src="/Bilder/Logos/villaklimatominiftx.webp"
                    alt="Mini-FTX logo"
                    fill
                    className="object-contain"
                  />
                </div>
              </div>

              {/* Mini-FTX Contact Form */}
              <div className="flex items-center justify-center">
                <CloudWatchForm />
              </div>
            </div>

            {/* Villaklimat Row */}
            <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
              {/* Villaklimat Text + Logo */}
              <div className="flex flex-col justify-center gap-6 p-8 bg-white shadow-lg rounded-xl">
                <div>
                  <Badge className="mb-4">Installation av FTX-system</Badge>
                </div>
                <div className="flex flex-col gap-2">
                  <a
                    href="https://villaklimat.se"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-2xl font-semibold tracking-tight hover:text-primary transition-colors"
                  >
                    Villaklimat.se
                  </a>
                  <p className="text-base leading-relaxed text-muted-foreground">
                    Din kompletta partner för klimatlösningar i villan. Vi
                    erbjuder ventilation, värme och kyla med fokus på
                    energieffektivitet och hälsosam inomhusmiljö.
                  </p>
                  <a
                    href="https://villaklimat.se"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center mt-2 text-sm font-medium text-primary hover:underline"
                  >
                    Besök villaklimat.se →
                  </a>
                </div>
                {/* Logo */}
                <div className="relative w-full h-24 mt-4">
                  <Image
                    src="/Bilder/Logos/logo-villaklimat.webp"
                    alt="Villaklimat logo"
                    fill
                    className="object-contain"
                  />
                </div>
              </div>

              {/* Villaklimat Contact Form */}
              <div className="flex items-center justify-center">
                <CloudWatchForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer7 />
    </>
  );
}
